<template>
  <div class="index-page">
    <div class="top-banner">
      <img :src="require('@/assets/banner-bg.png')"  alt="">
    </div>
    <van-tabs v-model="active" @click="changeTab" line-width="20px" title-active-color="#333" title-inactive-color="#666">
      <van-tab title="COSE证书查询"></van-tab>
      <van-tab title="授权机构查询"></van-tab>
      <van-tab title="项目管理办法"></van-tab>
    </van-tabs>
    <div class="m-pdf">
      <div id="pdf" class="pdfjs">
        <div class="pageContainer" @click="showPreview(0)">

          <img src="https://img.91zhiyi.com/cose/other/h5/cert_query.png" />
        </div>
        <!-- <div class="pageContainer" @click="showPreview(1)">
          <img :src="require('@/assets/pdf_new_2.png')" />
        </div>
        <div class="pageContainer" @click="showPreview(2)">
          <img :src="require('@/assets/pdf_new_3.png')" />
        </div>
        <div class="pageContainer" @click="showPreview(3)">

          <img :src="require('@/assets/pdf_new_4.png')" />
        </div> -->
      </div>
    </div>
    <!-- <iframe :src="data" class="iframe-box"></iframe> -->
  </div>
</template>
<script>
import Tab from 'vant/lib/tab'
import Tabs from 'vant/lib/tabs'
import ImagePreview from 'vant/lib/image-preview'
import { index} from "@/api/common.js"
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import 'vant/lib/image-preview/style'
import Pdfh5 from 'pdfh5'
// import 'pdfh5/css/pdfh5.css'
export default {
  metaInfo:{
    title: '项目管理办法',
  },
  data () {
    return {
      data: '/regulation1.pdf',
      active: 2,

    }
  },
  components: {
    'van-tabs':Tabs,
    'van-tab': Tab,
  },
  created () {
    // this.Getproject()
    
  },
  mounted () {
    const that = this
    setTimeout(() => {
      // this.pdfh5 = new Pdfh5('#pdf', { pdfurl: that.data, goto: 1, maxZoom: 4 })
      // this.pdfh5.on('ready', function () {
      //   console.log('总页数')
      // })
      // this.pdfh5.scrollEnable(true);
    }, 500)
    
  },
  methods: {
    showPreview(value) {
      ImagePreview({
        images: [
          'https://img.91zhiyi.com/cose/other/h5/cert_query.png',
          // require('@/assets/pdf_new_2.png'),
          // require('@/assets/pdf_new_3.png'),
          // require('@/assets/pdf_new_4.png')
        ],
        startPosition: value,
      })
    },
    // Getproject(){
    //    index("v2/project").then((res) => {
    //     if (res.code == 0) {
    //       this.data='https://query.91zhiyi.com'+res.data
    //     }
    //    })
    // },
    changeTab (value) {
      this.$router.push({ path: value === 1 ? '/certChannel': '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
.index-page {
  width: 100vw;
  min-height: 100vh;
  background-color: #f6f6f6;
  .top-banner {
    height: 1.44rem;
    width: 100%;
    img {
      height: 1.44rem;
      width: 100%;
    }
  }
  .m-pdf {
    width: 100vw;
    height: calc(100vh - 0.88rem);
    overflow: hidden;
    #pdf {
      overflow: auto;
      height: 100%;
    }
    .pageContainer {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
</style>
<style>
.van-tabs__line {
  background-color: #0751A8;
}
</style>